import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from '@/core/data-fetching/queryKeys';
import { billingSettingsService, type BillingSettingsData } from '../api/billing-settings.service';

export function useBillingSettings() {
  const client = useQueryClient();
  const query = useQuery({ queryKey: queryKeys.billingSettings, queryFn: () => billingSettingsService.get() });
  const save = useMutation({
    mutationFn: (patch: Partial<BillingSettingsData>) => billingSettingsService.update(patch),
    onSuccess: (data) => client.setQueryData(queryKeys.billingSettings, data),
  });
  return { query, save };
}
